import gsap from "gsap";
import { SplitText } from "gsap/SplitText";
import { colors } from "~/_variables";

export default function works() {
  const heading = SplitText.create(".section-works .heading", {
    type: "chars",
  });

  heading.chars.forEach((char, i) => {
    gsap.set(char, { color: colors[i % 7] });
  });

  gsap
    .timeline({
      scrollTrigger: {
        trigger: ".section-works .headline",
        start: "top 60%",
      },
    })
    .from(
      heading.chars,
      {
        autoAlpha: 0,
        duration: 0.2,
        ease: "none",
        stagger: {
          amount: 0.3,
        },
      },
      "<"
    )
    .to(
      heading.chars,
      {
        color: "#ffffff",
        duration: 0.2,
        ease: "none",
        stagger: {
          amount: 0.3,
        },
      },
      "<0.3"
    )
    .from(
      ".section-works .slider",
      {
        y: 75,
        autoAlpha: 0,
        ease: "expo.out",
        duration: 1.2,
      },
      "<"
    )
    .from(
      ".section-works .more",
      {
        y: 75,
        autoAlpha: 0,
        ease: "expo.out",
        duration: 1.2,
      },
      "<0.4"
    );
}
